export default __webpack_public_path__ + "static/media/brand-icons.ee26f57b.woff";